import React from "react";
import { useParams } from "react-router-dom";
import { FeedGrid } from "@/components/FeedGrid";
import { useI18n } from "@/i18n";

export default function CategoryPage() {
  const { slug } = useParams();
  const { catName } = useI18n();
  const name = catName(slug);
  return <FeedGrid key={slug} baseParams={{ category: slug }} title={name} icon={slug} description="" />;
}
